/**
 * Created by ok on 8/11/17.
 */
import React, {Component, PureComponent} from 'react'
import debounce from 'lodash/debounce'
import color from 'react-color/lib/helpers/color'

/**
 * This is a slightly changed version the ColorWrap component from react-color.
 * Mainly to overwrite the debounce function with a higher value to make the
 * sliders work more smoothly.
 *
 * @param Picker
 * @returns {ColorPicker}
 * @constructor
 */
export const EnhancedPicker = ( Picker ) => {
    class ColorPicker extends (PureComponent || Component) {
        constructor( props ) {
            super()

            this.state = {
                ...color.toState( props.color, 0 ),
            }

            this.debounce = debounce( ( fn, data, event ) => {
                fn( data, event )
            }, 250 )
        }

        componentWillReceiveProps( nextProps ) {
            this.setState( {
                ...color.toState( nextProps.color, this.state.oldHue ),
            } )
        }

        shouldComponentUpdate(nextProps){
            return true;
        }

        handleChange = ( data, event ) => {
            const isValidColor = color.simpleCheckForValidColor( data )
            if ( isValidColor ) {
                const colors = color.toState( data, data.h || this.state.oldHue )
                this.setState( colors )
                this.props.onChangeComplete && this.debounce( this.props.onChangeComplete, colors, event )
                this.props.onChange && this.props.onChange( colors, event )
            }
        }

        handleSwatchHover = ( data, event ) => {
            const isValidColor = color.simpleCheckForValidColor( data )
            if ( isValidColor ) {
                const colors = color.toState( data, data.h || this.state.oldHue )
                this.setState( colors )
                this.props.onSwatchHover && this.props.onSwatchHover( colors, event )
            }
        }

        render() {
            let optionalEvents = {}
            if ( this.props.onSwatchHover ) {
                optionalEvents.onSwatchHover = this.handleSwatchHover
            }

            return <Picker {...this.props} {...this.state}
                           onChange={this.handleChange} {...optionalEvents} />
        }
    }

    ColorPicker.defaultProps = {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1,
        },
    }

    return ColorPicker
}

export default EnhancedPicker;



// WEBPACK FOOTER //
// ./src/components/recoloring/EnhancedPicker.js